module.exports = __webpack_public_path__ + "static/img/CZ.44ed2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/CZ.png
// module id = ZYC/
// module chunks = 34